import { motion } from "framer-motion";
import { cva, type VariantProps } from "class-variance-authority";
import { Loader } from "@/components/ui/loader";

const indicatorVariants = cva("mt-2 flex items-center gap-2", {
  variants: {
    align: {
      center: "justify-center",
      start: "",
    },
  },
  defaultVariants: {
    align: "center",
  },
});

const loaderVariants = cva("shrink-0", {
  variants: {
    align: {
      center: "h-8 w-8",
      start: "h-5 w-5",
    },
  },
  defaultVariants: {
    align: "center",
  },
});

interface Props extends VariantProps<typeof indicatorVariants> {
  label?: string;
}

export const TypingIndicator = ({ align, label }: Props) => (
  <motion.div
    initial={{ opacity: 0, scale: 0.8 }}
    animate={{ opacity: 1, scale: 1 }}
    exit={{ opacity: 0, scale: 0.8 }}
    transition={{ duration: 0.3 }}
    className={indicatorVariants({ align })}
  >
    <Loader className={loaderVariants({ align })} />
    {label && (
      <p role="status" aria-live="polite" className="text-sm text-muted-foreground">
        {label}
      </p>
    )}
  </motion.div>
);
